import { Pipe } from 'angular2/core';
import { SortService, ISortSettingInstance } from './sort-service';

@Pipe({
    name: 'sort',
    pure: false
})
export class SortPipe {

	constructor(private service: SortService) {

	}

	public transform(collection: any[], args: any[]): any {
		let table: string = args[0];
		collection = this.service.sortCollection(collection, table);

		return collection;
	}
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/sort/sort-pipe.ts
 **/